import AnimationClip from '../AnimationClip';
import { Tween } from '@tweenjs/tween.js';
import GameObject from '../../../GameObject/GameObject';
import ElementComponent from '../../../Component/UI/Element';
import { AwaitIterators } from '../AnimationHelper';
import { delay } from '../../../Utility/Task/TaskQueue';
import ColorFilter from '../../../Component/ColorFilter';
import Armature from '../../../Prototype/Armature';
import { Point } from 'pixi.js';
import { RenderSystemEvent } from '../../Render/RenderSystem';
import { DragonbonesAnimationEvent } from '../../../Component/Dragonbones';

export class GiftBoxOpen extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        const box: GameObject = gameObject.find('box');
        const lid: GameObject = box.find('lid');
        const open: GameObject = box.find('open');

        const boxElem: ElementComponent = box.getComponent(ElementComponent);
        const lidElem: ElementComponent = lid.getComponent(ElementComponent);
        const openElem: ElementComponent = open.getComponent(ElementComponent);

        let colorFilter: ColorFilter = gameObject.getComponent(ColorFilter);
        if (!colorFilter) {
            colorFilter = gameObject.addComponent<ColorFilter>(ColorFilter);
        }

        gameObject.getComponent(ElementComponent).rotation = 0;
        boxElem.scale.set(0.55, 0.55);
        colorFilter.brightness = 1;

        // Dragonbones effect.
        const armature: Armature = GameObject.Instantiate(Armature, {
            dragonbonesName: 'UI_VFX',
            armatureName: 'giftbox_VFX',
            animationName: 'animation',
            position: new Point(130, 12),
        });
        gameObject.addChild(armature);

        armature.on(DragonbonesAnimationEvent.COMPLETE, () => {
            armature.destroy();
        });

        const colorTween: Tween = this.getTween(colorFilter);
        const scaleTween: Tween = this.getTween(boxElem.scale);
        const lidTweenTopLeft: Tween = this.getTween(lidElem.offsetTopLeft);
        const lidTweenBottomRight: Tween = this.getTween(
            lidElem.offsetBottomRight
        );
        const openTweenTopLeft: Tween = this.getTween(openElem.offsetTopLeft);
        const openTweenBottomRight: Tween = this.getTween(
            openElem.offsetBottomRight
        );

        colorTween.to({ brightness: 1.5 }, 100);
        scaleTween.to({ x: 0.6, y: 0.4 }, 100);

        yield* AwaitIterators([
            this.startTween(colorTween),
            this.startTween(scaleTween),
        ]);

        scaleTween.to({ x: 0.5, y: 0.65 }, 100);
        lidTweenTopLeft.to({ y: 65 }, 100);
        lidTweenBottomRight.to({ y: 65 }, 100);
        openTweenTopLeft.to({ y: -15 }, 100);
        openTweenBottomRight.to({ y: -15 }, 100);

        yield* AwaitIterators([
            this.startTween(scaleTween),
            this.startTween(lidTweenTopLeft),
            this.startTween(lidTweenBottomRight),
            this.startTween(openTweenTopLeft),
            this.startTween(openTweenBottomRight),
        ]);

        yield* delay(400);

        scaleTween.to({ x: 0.55, y: 0.55 }, 300);
        lidTweenTopLeft.to({ y: 45 }, 300);
        lidTweenBottomRight.to({ y: 45 }, 300);
        openTweenTopLeft.to({ y: 0 }, 300);
        openTweenBottomRight.to({ y: 0 }, 300);
        colorTween.to({ brightness: 1 }, 300);

        yield* AwaitIterators([
            this.startTween(scaleTween),
            this.startTween(lidTweenTopLeft),
            this.startTween(lidTweenBottomRight),
            this.startTween(openTweenTopLeft),
            this.startTween(openTweenBottomRight),
            this.startTween(colorTween),
        ]);

        if (gameObject && !gameObject.destroyed) {
            gameObject.removeComponent(ColorFilter);
        }
    }
}
